export const stepBar=[
    {
        step: '1',
        text: "Copie o código de barras acima"
    },
    {
        step: '2',
        text: "Acesse o app do seu banco ou internet banking de preferência"
    },
    {
        step: '3',
        text: "Escolha pagar boleto, cole o código e finalize o pagamento"
    }
]